import hasQueryCondition from './hasQueryCondition';
import toArray from './toArray';
export default function getFlushedStyles(styles) {
  return toArray(styles).reduce(function (css, style) {
    var sheet = style.sheet;
    var content = '';

    if (sheet && sheet.cssRules) {
      content = Array.from(sheet.cssRules).map(function (rule) {
        return rule ? rule.cssText : '';
      }).join('\n');
    } else if (style.textContent) {
      content = style.textContent;
    }

    if (!content) {
      return css;
    }

    if (style.media && hasQueryCondition(style.media)) {
      content = "@media " + style.media + " { " + content + " }";
    }

    return (css + "\n" + content).trim();
  }, '');
}